import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-widget-counter-band-triple",
    templateUrl: "./widget-counter-band-triple.component.html",
    styleUrls: [
        "./widget-counter-band-triple.component.scss",
        "../../styles/shared-global.scss",
    ],
    changeDetection: ChangeDetectionStrategy.Eager
})

/**
 * Counter band (triple) entry componet
 */
export class WidgetCounterBandTripleComponent {
  @Input() title: string = "";
  @Input() subtitle: string = "";
  @Input() title1: string = "";
  @Input() value1: string = "";
  @Input() title2: string = "";
  @Input() value2: string = "";
  @Input() title3: string = "";
  @Input() value3: string = "";
}
